import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorPageCoverPictureEntry: LoadableType<any> = LoadableAfterPaint({
	loader: async () => {
		const { EditorPageCoverPictureEntry } = await import(
			/* webpackChunkName: "loadable-EditorCoverPictureEditorPageCoverPictureEntry" */ '../src/EditorCoverPicture/EditorPageCoverPictureEntry.tsx'
		);
		return EditorPageCoverPictureEntry;
	},
});
